import React, { useCallback } from 'react';
import useResponsiveness from '@/hooks/useResponsiveness';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import { useRouter } from 'expo-router';

const ModelsRouteNavigationHeaderRight = React.memo(() => {
  const { isXS } = useResponsiveness();
  const router = useRouter();

  const handleSearchClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    router.push('/models/search');
  }, [router]);

  return (
    <NavigationBarButtonContainer rightPadding>
      {isXS && (
        <NavigationBarButton
          icon="magnifying-glass"
          onPress={handleSearchClick}
        />
      )}
    </NavigationBarButtonContainer>
  );
});

ModelsRouteNavigationHeaderRight.displayName = 'ModelsRouteNavigationHeaderRight';

const ModelsRouteNavigationOptions = {
  title: 'Models',
  headerTitle: () => null,
  headerBackVisible: false,
  headerRight: () => <ModelsRouteNavigationHeaderRight />
};

export default ModelsRouteNavigationOptions;
